<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box" >
    <div class="条件区">
      <!-- <div>
        <span class="relative" (click)="isShowCondition = !isShowCondition" (click)="sendQuery()">
          <span class="to-top" [ngClass]="{ 'translate-180': !isShowCondition }"></span>
        </span>
        <strong class="black-title" style="margin-left: 18px">{{ "Condition" | translate }}</strong>
      </div> -->
      <app-wmsm-contract [ShowSite]="true" [ShowTemplate]="true" [ShowSchedule]="false" [ShowAdd]="role0"
        (listenForm)="getFormValue($event)" (outQuery)="getQuery($event)"
        [QueryFromContract]="onQueryClick()"></app-wmsm-contract>
    </div>

    <!-- The fourth line -->
    <nz-card>
      <!-- <div nz-row>
        <div nz-col nzPush="0"  *ngIf="role0">
          <button nz-button  class="default-button" nzType="primary"   (click)="showModal()"  >
            <span nz-icon nzType="plus" nzTheme="outline"></span>{{
            "ADDcontractTemplate" | translate}}</button>
        </div>

      </div> -->
      <div class="margin-top-10">
        <strong class="margin-left-8 result">{{ "Results" | translate}}({{total}})</strong>
      </div>
      <div class="合同模板">
        <nz-table #colSpanTable [nzData]="listofreportdata" style="margin-bottom: 10px" nzSize="middle"
          nzShowSizeChanger [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize'
          [nzPageIndex]='pageIndex' [nzScroll]="{ x:'1530px'}">
          <thead>
            <tr>
              <th scope="col" nzWidth="150px" [nzSortFn]="true" (nzSortOrderChange)="sortChange($event)">{{
                "contractname"
                | translate}}</th>
              <th scope="col" nzWidth="150px" [nzSortFn]="true" (nzSortOrderChange)="sortChangeEN($event)">{{
                "ENcontractname" | translate}}</th>
              <th scope="col" nzWidth="110px" [nzSortFn]="true" (nzSortOrderChange)="sortChangeversion($event)">{{
                "contractversion" | translate}}</th>
              <th scope="col" nzWidth="100px">{{ "Form Number" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "background" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "purpose" | translate}}</th>
              <th scope="col" nzWidth="50px">{{ "state" | translate}}</th>
              <th scope="col" nzWidth="50px">{{ "Site" | translate}}</th>
              <th scope="col" nzWidth="100px" [nzSortFn]="true" (nzSortOrderChange)="sortChangeMDate($event)">{{ "MDate"  | translate}}</th>
              <th scope="col" nzWidth="90px">{{ "MUser" | translate}}</th>
              <th scope="col" nzWidth="70px">{{ "ApprovalTimeLimit" | translate}}</th>
              <th scope="col" nzWidth="60px" [nzRight]="fixedColumn">{{ "template" | translate}}</th>
              <!-- <th scope="col" nzWidth="50px"  *ngIf="role0">{{"Delete"| translate}}</th> -->
              <th scope="col" nzWidth="150px" *ngIf="role0" [nzRight]="fixedColumn">{{ "act" | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of listofreportdata">
              <!-- admin编辑 -->


              <td>{{data.chContractName}}</td>
              <td>{{data.enContractName}}</td>
              <td>{{data.versions}}</td>
              <td>{{data.formNumber}}</td>
              <td>{{data.backGround}}</td>
              <td>{{data.goal}}</td>
              <td>{{data.status}}</td>
              <td>{{data.site}}</td>
              <td>{{data.mDate | date:'yyyy-MM-dd'}}</td>
              <td>{{data.mUser}}</td>
              <td>{{data.approvalTimeLimit}}</td>
              <td [nzRight]="fixedColumn"  style="color: rgb(57, 129, 223);text-align:center;"><span style="font-size: 20px;cursor: pointer;" nz-icon nzType="file" nzTheme="outline" (click)="download(data)" nz-tooltip nzTooltipTitle="{{data.fileName}}"></span>
              </td>

              <td *ngIf="select" [nzRight]="fixedColumn">
                <span nz-icon nzType="edit" nzTheme="twotone"
                  style="font-size: 20px; margin-right: 40px;cursor: pointer;" (click)="EditShowModal(data)"></span>
                <span nz-icon nzType="copy" nzTheme="twotone" style="font-size: 20px;cursor: pointer;"
                  (click)="CopyShowModal(data)"></span>
                <a nz-popconfirm nzPopconfirmTitle="{{'DeleteContractTemplate'| translate }}"
                  nzPopconfirmPlacement="bottom" (nzOnConfirm)="confirm(data)" (nzOnCancel)="cancel()">
                  <span nz-icon nzType="delete" nzTheme="outline"
                    style="font-size: 20px;cursor: pointer;margin-left: 40px;"></span>
                </a>

              </td>
              <!-- siteadmin自己厂区编辑 -->
              <td *ngIf="this.role4 && sitename==data.site" [nzRight]="fixedColumn">
                <span nz-icon nzType="edit" nzTheme="twotone"
                  style="font-size: 20px; margin-right: 50px;cursor: pointer;" (click)="EditShowModal(data)"></span>
                <span nz-icon nzType="copy" nzTheme="twotone"
                  style="font-size: 20px; margin-left: 10px;cursor: pointer;" (click)="CopyShowModal(data)"></span>
                <a nz-popconfirm nzPopconfirmTitle="{{'DeleteContractTemplate'| translate }}"
                  nzPopconfirmPlacement="bottom" (nzOnConfirm)="confirm(data)" (nzOnCancel)="cancel()">
                  <span nz-icon nzType="delete" nzTheme="outline"
                    style="font-size: 20px;cursor: pointer;margin-left: 40px;"></span>
                </a>

              </td>
              <!-- siteadmin 别的厂区复制 -->
              <td *ngIf="this.role4 && sitename!=data.site" [nzRight]="fixedColumn">
                <span style="font-size: 20px; margin-right: 81px;cursor: pointer;"></span>
                <span nz-icon nzType="copy" nzTheme="twotone"
                  style="font-size: 20px; margin-left: 10px;cursor: pointer;" (click)="CopyShowModal(data)"></span>
              </td>
            </tr>
          </tbody>
        </nz-table>
        <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="total" [nzSize]="'small'"
          nzShowSizeChanger [nzPageSizeOptions]="[10,15,20]" [nzPageSize]='pageSize' [nzPageSizeOptions]="[10, 20, 50,100]"
          (nzPageSizeChange)="nzPageSizeChange($event)" (nzPageIndexChange)="nzPageIndexChange($event)"></nz-pagination>
        <ng-template #renderItemTemplate let-type let-page="page">

          <a *ngIf="type === 'page'">{{ page }}</a>
          <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
          <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
        </ng-template>
      </div>
    </nz-card>
    <!-- <button nz-button style="left: 28px;" class="default-button" nzType="primary" (click)="downloadTable()">{{
      "Dowmload" | translate}}</button> -->
  </div>
</nz-spin>


<nz-modal [(nzVisible)]="isVisible" nzTitle="{{nzTitle}}" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()"
  nzOkText="{{'Submit'|translate}}">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="validateForm">
      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "contracttype" |
                translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <nz-select formControlName="TypeCode">
                <nz-option *ngFor="let option of TypeList" nzValue="{{option.code}}/{{option.text}}"
                  nzLabel="{{option.code}}/{{option.text}}"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "contractname" |
                translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <input nz-input placeholder="{{''|translate}}" formControlName="CNContractName" required />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "ENcontractname" |
                translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <input nz-input placeholder="{{''|translate}}" formControlName="ENContractName" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "contractversion" |
                translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <input nz-input placeholder="{{''|translate}}" formControlName="ModalVersions" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "FORM Number" |
                translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <!-- <nz-textarea-count > -->
              <input nz-input placeholder="{{''|translate}}" formControlName="FORMNumber" />
              <!-- <textarea rows="1" nz-input formControlName="FORMNumber"
                 ></textarea> -->
              <!-- </nz-textarea-count> -->
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "Site" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <nz-select formControlName="ModalSite">
                <nz-option nzValue="ALL" nzLabel="ALL" *ngIf="select"></nz-option>
                <nz-option *ngFor="let option of SiteList" [nzValue]="option.siteCode"
                  [nzLabel]="option.siteName"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "ApprovalTimeLimit" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="8">
              <input nz-input placeholder="{{'Day'|translate}}" formControlName="Limit" />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "state" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <nz-radio-group formControlName="ModalType">
                <label nz-radio nzValue="Y">{{ "Effective" | translate}}</label>
                <label nz-radio nzValue="N">{{ "loseEfficacy" | translate}}</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font">{{ "background" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <nz-textarea-count [nzMaxCharacterCount]="350">
                <textarea rows="3" nz-input formControlName="Background"
                  placeholder="{{'选填(350字)'|translate}}"></textarea>
              </nz-textarea-count>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font">{{ "purpose" | translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <nz-textarea-count [nzMaxCharacterCount]="350">
                <textarea rows="3" nz-input formControlName="Purpose" placeholder="{{'选填(350字)'|translate}}"></textarea>
              </nz-textarea-count>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row>
        <div nz-col nzSpan="18">
          <nz-form-item>
            <nz-form-label nzSpan="8">
              <div class="width-100-percent label-font"><span style="color: red;"> *</span>{{ "TemplateUpload" |
                translate}}
              </div>
            </nz-form-label>
            <nz-form-control nzSpan="16">
              <nz-upload *ngIf="uploadedFileName == null" [nzBeforeUpload]="beforeUpload"
                [nzHeaders]="{ authorization: 'authorization-text' }" (nzChange)="handleChange($event)">
                <button nz-button nzType="primary" class="default-button">
                  <span nz-icon nzType="upload"></span>
                  {{"uploadAttachment" | translate}}
                </button>
              </nz-upload>
              <div *ngIf="uploadedFileName != null" style="display: flex; align-items: center;">
                <span class="truncate" style="margin-right: 10px;">{{uploadedFileName}}</span>
                <span nz-icon nzType="download" nzTheme="outline" class="icon-hover"
                  style="font-size: 20px; color: blue; cursor: pointer; margin-right: 10px;" *ngIf="fileToken"
                  (click)="downloadFile()"></span>
                <span nz-icon nzType="delete" nzTheme="twotone" class="icon-hover"
                  style="font-size: 20px; cursor: pointer;" (click)="removeFile()"></span>
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>


      </div>


    </form>
  </ng-container>

</nz-modal>
